import { Controller } from 'stimulus'
import IMask from 'imask'

/**
 * PhoneController is a Stimulus controller that formats a phone number input field.
 */
export default class extends Controller {
  declare phoneFormattedTarget: HTMLInputElement
  declare phoneTarget: HTMLInputElement

  static targets = ['phoneFormatted', 'phone']

  // use IMask to set allowed patterns for input fields:
  // https://imask.js.org/
  phoneMask = IMask.createMask({ mask: '(000) 000-0000' })

  connect() {
    const initialPhoneValue = this.phoneTarget.value
    this.phoneMask.resolve(initialPhoneValue)
    this.phoneFormattedTarget.value = this.phoneMask.value
  }

  updatePhoneFormatted(event: InputEvent) {
    const target = event.target as HTMLInputElement
    this.phoneMask.resolve(target.value)
    this.phoneFormattedTarget.value = this.phoneMask.value

    // update hidden phone field with unmasked value
    this.phoneTarget.value = this.phoneMask.unmaskedValue
  }
}
